<template>
  <div class="container">
    <Header title="E-wallet Details" />
    <div>
      <Cart :contentFor="'EwalletDetails'" />
    </div>
    <Item :contentFor="'EwalletDetails'" />
    <DetailPengiriman :contentFor="'EwalletDetails'" />
    <div
      class="d-flex align-items-center badge-agree-trx p-3 mt-5"
      @click="setAgree"
    >
      <div class="pr-3">
        <input
          type="checkbox"
          id="agree"
          name="agree_trx"
          :value="!isAgree"
          v-model="isAgree"
        />
      </div>
      <div>
        <p class="mb-0 text-red-300">
          Apakah anda yakin dengan nominal dan nomor tujuan transaksi diatas ?
        </p>
      </div>
    </div>
    <FooterProduct v-if="isAgree" :contentFor="'EwalletDetails'" />
  </div>
</template>

<script>
import DetailPengiriman from "@/components/Catalog/DetailPengiriman.vue";
import Item from "@/components/Catalog/ListItem.vue";
import Cart from "@/components/Catalog/AlertCart.vue";
import Header from "@/components/Catalog/Header.vue";
import FooterProduct from "@/components/Catalog/FooterProduct.vue";

export default {
  components: {
    Header,
    Cart,
    Item,
    DetailPengiriman,
    FooterProduct
  },
  data() {
    return {
      isAgree: false
    };
  },
  computed: {
    cekEwallet() {
      return this.$store.state.cartEwallet;
    }
  },
  methods: {
    setAgree() {
      this.isAgree = !this.isAgree;
    }
  }
};
</script>

<style scoped>
.text-red-300 {
  color: #ca6065;
}

.badge-agree-trx {
  background-color: #fddbdd;
  border-radius: 10px;
}
</style>
